import { render, staticRenderFns } from "./JobsEvidenceDetailOnMapFloat.vue?vue&type=template&id=036f15c2&scoped=true&"
import script from "./JobsEvidenceDetailOnMapFloat.vue?vue&type=script&lang=js&"
export * from "./JobsEvidenceDetailOnMapFloat.vue?vue&type=script&lang=js&"
import style0 from "./JobsEvidenceDetailOnMapFloat.vue?vue&type=style&index=0&id=036f15c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f15c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCol,VDivider,VRow,VSlideXTransition,VTimeline,VTimelineItem})
